<template>
  <b-row :class="level_valid_cls">
    <b-col>
      <b-button-group>
        <b-button @click="ac(1)" variant="success">S</b-button>
        <b-button @click="ac(2)" variant="success">V</b-button>
        <b-button @click="ac(3)" variant="success">C</b-button>
        <b-button @click="ac(4)" variant="success">O</b-button>
        <b-button @click="ac(5)" variant="primary">IO</b-button>
        <b-button @click="ac(6)" variant="primary">DO</b-button>
        <b-button @click="ac(7)" variant="primary">MA</b-button>
        <b-button>A</b-button>
        <b-button>전</b-button>
        <b-button>전.목</b-button>
      </b-button-group>

      <div>{{ sencommand_selected }}</div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
const senStore = "senStore";
export default {
  computed: {
    ...mapGetters(senStore, ["GET_SENCOMMAND_OPTIONS"]),
    ...mapState(senStore, ["sencommand_options", "sencommand_selected"]),
  },
  methods: {
    ...mapActions(senStore, ["AC_SENCOMMAND_SELECTED"]),
    ac(payload) {
      this.AC_SENCOMMAND_SELECTED(payload);
    },
  },
};
</script>


<style lang="scss" scoped>
</style>